// EN/ES translations for portal users (Picker / Presser / Packer).
// Convention: KEY is the English text. Looking up a missing key in `es`
// falls through to the English string in `en`, which falls through to the
// raw key — so a typo or untranslated string still renders readably.
//
// Where a string has placeholders, use {name}, {n}, etc. — the t()
// function interpolates them. Spanish translations preserve the same
// placeholders so the t() call works identically in either language.

export const translations = {
    en: {
        // ── Common: navigation, status, modals ─────────────────────────────
        'Cancel':                       'Cancel',
        'Confirm':                      'Confirm',
        'OK':                           'OK',
        'Yes':                          'Yes',
        'No':                           'No',
        'Save':                         'Save',
        'Done':                         'Done',
        'Close':                        'Close',
        'Back':                         'Back',
        'Next':                         'Next',
        'Loading…':                     'Loading…',
        'Loading order…':               'Loading order…',
        'Searching…':                   'Searching…',
        'Sign out':                     'Sign out',
        'Network error. Please try again.': 'Network error. Please try again.',
        'Could not connect. Please try again.': 'Could not connect. Please try again.',
        'Search by customer name or order number…': 'Search by customer name or order number…',
        'Search order or scan barcode…': 'Search order or scan barcode…',
        'Scan barcode…':                'Scan barcode…',
        'Scan parent product barcode…': 'Scan parent product barcode…',
        'Scan order barcode':           'Scan order barcode',
        'Open camera scanner':          'Open camera scanner',
        'No results found.':            'No results found.',
        'No items to pick on this order.': 'No items to pick on this order.',
        'Order is currently being picked.': 'Order is currently being picked.',
        'Order is currently being picked by another user.': 'Order is currently being picked by another user.',
        'Sort:':                        'Sort:',
        'Show:':                        'Show:',
        'Refresh':                      'Refresh',

        // ── Picking Portal ─────────────────────────────────────────────────
        'Picking Portal':               'Picking Portal',
        'No location assigned. Use "View as" in the admin bar to select a location, or sign in as a location user.':
            'No location assigned. Use "View as" in the admin bar to select a location, or sign in as a location user.',
        'Multiple locations ({n})':     'Multiple locations ({n})',
        'All Locations':                'All Locations',
        'Tap to dismiss':               'Tap to dismiss',
        'Picked':                       'Picked',
        'Unpicked':                     'Unpicked',
        'Mark as picked':               'Mark as picked',
        'Items remaining':              'Items remaining',
        'Items picked':                 'Items picked',
        'Total items':                  'Total items',
        'Complete!':                    'Complete!',
        'Pick complete':                'Pick complete',
        'All items picked':             'All items picked',
        'Save & finish':                'Save & finish',
        'Save and exit':                'Save and exit',
        'Pause and exit':               'Pause and exit',
        'Back to Order Search':         'Back to Order Search',
        'Open in admin':                'Open in admin',
        'Notes':                        'Notes',
        'Customer':                     'Customer',
        'Order':                        'Order',
        'Bin':                          'Bin',
        'Bin location':                 'Bin location',
        'Set bin':                      'Set bin',
        'No bin assigned':              'No bin assigned',
        'This order has been taken by another picker. Your picks have not been saved.':
            'This order has been taken by another picker. Your picks have not been saved.',
        'Manual':                       'Manual',
        'Scan':                         'Scan',
        'Scanned':                      'Scanned',
        'Type:':                        'Type:',
        'Show: All':                    'Show: All',
        'Base':                         'Base',
        'Embellishments':               'Embellishments',
        'Embel.':                       'Embel.',
        'All':                          'All',
        'Filter':                       'Filter',
        'Filter by location':           'Filter by location',
        'Sort: Custom':                 'Sort: Custom',
        'Sort: Name':                   'Sort: Name',
        'Sort: Newest':                 'Sort: Newest',
        'Sort: Oldest':                 'Sort: Oldest',
        'Custom':                       'Custom',
        'Newest':                       'Newest',
        'Oldest':                       'Oldest',
        'Name':                         'Name',
        'Could not save your picks. Please try again.': 'Could not save your picks. Please try again.',
        'Are you sure you want to exit? Your progress will be saved.':
            'Are you sure you want to exit? Your progress will be saved.',
        'For fullscreen: tap':          'For fullscreen: tap',
        'Share':                        'Share',
        'Add to Home Screen':           'Add to Home Screen',
        'Open & Print Label':           'Open & Print Label',
        'Pickup':                       'Pickup',
        'Shipping':                     'Shipping',
        'Failed to load order.':        'Failed to load order.',
        'Product Not In Order':         'Product Not In Order',
        'Already Fully Scanned':        'Already Fully Scanned',
        'Debag {title} before continuing': 'Debag {title} before continuing',
        'Debag — {title}':              'Debag — {title}',
        'Debagged':                     'Debagged',
        'On Hand: {n}':                 'On Hand: {n}',
        'Available: {n}':               'Available: {n}',
        '← Back & Save':                '← Back & Save',
        '← Back to search':             '← Back to search',
        '← Return to Order':            '← Return to Order',
        'Saving…':                      'Saving…',
        '✓ Mark as Picked & Back to Search': '✓ Mark as Picked & Back to Search',
        '↩ Sign Out':                   '↩ Sign Out',
        'Sign Out':                     'Sign Out',
        'Could not update Shopify — tap Mark as Picked to retry.':
            'Could not update Shopify — tap Mark as Picked to retry.',
        'Could not update Shopify — tap Complete to retry.':
            'Could not update Shopify — tap Complete to retry.',
        'Could not claim order. Please try again.': 'Could not claim order. Please try again.',
        'Please open this order from the search page.':
            'Please open this order from the search page.',
        'Location':                     'Location',
        'Type':                         'Type',
        'No location':                  'No location',
        'No unfulfilled orders found for "{q}"': 'No unfulfilled orders found for "{q}"',
        'On Hand:':                     'On Hand:',
        'Available:':                   'Available:',
        'Scan Barcode':                 'Scan Barcode',
        'Failed to load portal state.': 'Failed to load portal state.',
        'Failed to load order details.':'Failed to load order details.',
        'No bundle in this order matches the scanned barcode.': 'No bundle in this order matches the scanned barcode.',
        'Barcode:':                     'Barcode:',
        'Garment':                      'Garment',
        'Partially Picked':             'Partially Picked',
        '← Back to Board':              '← Back to Board',
        '✓ Done — Move to Pressed':     '✓ Done — Move to Pressed',
        'Image':                        'Image',
        'Item':                         'Item',
        'Unfulfilled':                  'Unfulfilled',
        'No orders found for "{q}"':    'No orders found for "{q}"',
        'QA Failed —':                  'QA Failed —',
        'Next →':                       'Next →',
        '← Back':                       '← Back',
        'Partial Fulfillment':          'Partial Fulfillment',
        'Packing Complete —':           'Packing Complete —',
        'Passed QC —':                  'Passed QC —',
        'Excluded —':                   'Excluded —',
        'item':                         'item',
        'items':                        'items',
        'Bundle':                       'Bundle',
        'Splitting…':                   'Splitting…',
        'Split Fulfillment — {n} Item{s} Ready →': 'Split Fulfillment — {n} Item{s} Ready →',
        'Fulfillment Split':            'Fulfillment Split',
        '{n} item{s} moved into a ready-to-ship fulfillment order in Shopify.':
            '{n} item{s} moved into a ready-to-ship fulfillment order in Shopify.',
        'Fulfillment failed':           'Fulfillment failed',
        'Network error creating fulfillment': 'Network error creating fulfillment',
        'No unscanned item found for barcode: {code}': 'No unscanned item found for barcode: {code}',
        'Every item in this order has already passed QC. Use Reset Packing History on the order page to start over.':
            'Every item in this order has already passed QC. Use Reset Packing History on the order page to start over.',
        'done':                         'done',
        'Unit':                         'Unit',
        'of':                           'of',
        'Not Picked & Pass':            'Not Picked & Pass',
        'Not Picked & Fail':            'Not Picked & Fail',
        'Pass QC':                      'Pass QC',
        'Fail QC':                      'Fail QC',
        'QC Failed —':                  'QC Failed —',
        'This item has already been QC\'d and the order only contains one of it.':
            'This item has already been QC\'d and the order only contains one of it.',
        'of this item have already been QC\'d.':
            'of this item have already been QC\'d.',
        'Already QC\'d':                'Already QC\'d',
        'The shipping rate session expired before Shopify finished generating the label. No charge was completed. Tap Retry, then tap "Fulfill & Create Label" again to get a fresh rate.':
            'The shipping rate session expired before Shopify finished generating the label. No charge was completed. Tap Retry, then tap "Fulfill & Create Label" again to get a fresh rate.',
        'This order has already been transferred to its pickup location. No action available here.':
            'This order has already been transferred to its pickup location. No action available here.',
        'This order has already been fulfilled. No action available.':
            'This order has already been fulfilled. No action available.',
        'Create Label & Transfer To Pickup Location (Partial)': 'Create Label & Transfer To Pickup Location (Partial)',
        'Create Label & Transfer To Pickup Location':          'Create Label & Transfer To Pickup Location',
        'Print Bulk Delivery Slip':             'Print Bulk Delivery Slip',
        'Print Bulk Delivery Slip (Partial)':   'Print Bulk Delivery Slip (Partial)',
        'Partially Fulfill Order':      'Partially Fulfill Order',
        'UPS Ground':                   'UPS Ground',
        'Confirm & Buy Label':          'Confirm & Buy Label',
        'Label purchased':              'Label purchased',
        'Transferred to pickup location':'Transferred to pickup location',
        'Open & Print Packing Slip':    'Open & Print Packing Slip',
        'Retry':                        'Retry',

        // ── Pressing Portal ────────────────────────────────────────────────
        'Pressing Portal':              'Pressing Portal',
        'No bundles to press.':         'No bundles to press.',
        'Return to Search':             'Return to Search',
        'Multiple Players':             'Multiple Players',
        'Product':                      'Product',
        'Player':                       'Player',
        'Players':                      'Players',
        'Unpressed':                    'Unpressed',
        'Pressed':                      'Pressed',
        'PRESSED':                      'PRESSED',
        'Now Pressing':                 'Now Pressing',
        'Press':                        'Press',
        'Mark as pressed':              'Mark as pressed',
        'Mark as unpressed':            'Mark as unpressed',
        'Bundles':                      'Bundles',
        'Items':                        'Items',
        'Temp':                         'Temp',
        'Pressure':                     'Pressure',
        'Time':                         'Time',
        'Peel':                         'Peel',
        'Recipe':                       'Recipe',
        'Pressing instructions':        'Pressing instructions',
        'Not in This Order':            'Not in This Order',
        'Already Pressed':              'Already Pressed',
        'This item has already been moved to':  'This item has already been moved to',
        'and the order only contains one of it.': 'and the order only contains one of it.',
        'All':                          'All',
        'of this item have already been moved to': 'of this item have already been moved to',
        'Are you sure you want to exit? Your pressing progress will be saved.':
            'Are you sure you want to exit? Your pressing progress will be saved.',
        'Save & exit':                  'Save & exit',
        'Open admin':                   'Open admin',

        // ── Packing / QC Portal ────────────────────────────────────────────
        'Packing Portal':               'Packing Portal',
        'Select location…':             'Select location…',
        'Enter PIN':                    'Enter PIN',
        'PIN must be 4 digits.':        'PIN must be 4 digits.',
        'Invalid PIN. Please try again.': 'Invalid PIN. Please try again.',
        'Please select a portal type.': 'Please select a portal type.',
        'READY FOR QC':                 'READY FOR QC',
        'PASSED QC':                    'PASSED QC',
        'SEND FOR REWORK':              'SEND FOR REWORK',
        'Not Picked':                   'Not Picked',
        'Not Pressed':                  'Not Pressed',
        'Not Picked & Pass':            'Not Picked & Pass',
        'Not Picked & Fail':            'Not Picked & Fail',
        'Front':                        'Front',
        'Back side':                    'Back side',
        'Pass':                         'Pass',
        'Fail':                         'Fail',
        'Pass or fail this item first': 'Pass or fail this item first',
        'has not been marked yet.':     'has not been marked yet.',
        'You scanned':                  'You scanned',
        'it opens as soon as you decide.': 'it opens as soon as you decide.',
        'Stay on this item':            'Stay on this item',
        'All items packed':             'All items packed',
        'Scan a barcode or select an item from the queue below':
            'Scan a barcode or select an item from the queue below',
        'Now Inspecting':               'Now Inspecting',
        'Already QC\'d':                'Already QC\'d',
        'This item has already been QC\'d and the order only contains one of it.':
            'This item has already been QC\'d and the order only contains one of it.',
        'of this item have already been QC\'d.':
            'of this item have already been QC\'d.',
        'Select the failure reason':    'Select the failure reason',
        'What should happen to this item?': 'What should happen to this item?',
        'Item needs to be re-pressed. Packing session will be saved and paused.':
            'Item needs to be re-pressed. Packing session will be saved and paused.',
        'Exclude this item. Continue packing and fulfill the rest.':
            'Exclude this item. Continue packing and fulfill the rest.',
        'Send for Rework':              'Send for Rework',
        'Exclude & Continue':           'Exclude & Continue',
        'QC Failed':                    'QC Failed',
        'Reason':                       'Reason',
        'Wrong size':                   'Wrong size',
        'Wrong color':                  'Wrong color',
        'Wrong number':                 'Wrong number',
        'Wrong name':                   'Wrong name',
        'Wrong logo':                   'Wrong logo',
        'Misalignment':                 'Misalignment',
        'Print quality':                'Print quality',
        'Damaged':                      'Damaged',
        'Other':                        'Other',
        'Buy Label':                    'Buy Label',
        'Fulfill & Create Label':       'Fulfill & Create Label',
        'International Shipment':       'International Shipment',
        'This is an international shipment, and will need to be shipped through the Shopify admin console.':
            'This is an international shipment, and will need to be shipped through the Shopify admin console.',
        'Destination':                  'Destination',
        'Print Packing Slip':           'Print Packing Slip',
        'Packing slip printed — finish in Shopify admin':
            'Packing slip printed — finish in Shopify admin',
        'Not a Ground Shipment':        'Not a Ground Shipment',
        'Please ship using the Shopify console. This is not a ground shipment, and the customer paid for':
            'Please ship using the Shopify console. This is not a ground shipment, and the customer paid for',
        'The order is still split and the packing slip still prints — only the UPS Ground label is skipped.':
            'The order is still split and the packing slip still prints — only the UPS Ground label is skipped.',
        'Packing slip printed — ship in Shopify admin':
            'Packing slip printed — ship in Shopify admin',
        'customer paid for':            'customer paid for',
        'Canada — UPS Standard. Customs are declared from the order prices; duties and brokerage are collected from the recipient on delivery.':
            'Canada — UPS Standard. Customs are declared from the order prices; duties and brokerage are collected from the recipient on delivery.',
        'Print Label':                  'Print Label',
        'Print packing slip':           'Print packing slip',
        'Mark as Ready for Pickup':     'Mark as Ready for Pickup',
        'Splitting fulfillment…':       'Splitting fulfillment…',
        'Getting shipping rate…':       'Getting shipping rate…',
        'Generating packing slip…':     'Generating packing slip…',
        'Purchasing label…':            'Purchasing label…',
        'Loading PDF…':                 'Loading PDF…',
        'Print preview':                'Print preview',
        'Transfer':                     'Transfer',
        'Mark Picked Up':               'Mark Picked Up',
        'Pickup location':              'Pickup location',

        // ── Multi-location picker (Picking) ─────────────────────────────────
        'Which location are you working at?': 'Which location are you working at?',
        "This order is split across multiple locations. Choose the one you're working at — your scans and saves will be recorded there.":
            "This order is split across multiple locations. Choose the one you're working at — your scans and saves will be recorded there.",
        '← Cancel — Back to Search':   '← Cancel — Back to Search',
        'Working at:':                  'Working at:',

        // ── Pressing + QC board ────────────────────────────────────────────
        'Close & Save Order':           'Close & Save Order',
        'Pressing Not Necessary':       'Pressing Not Necessary',

        // ── QC action bar (shipping labels / packing slips) ────────────────
        'Label could not be created':   'Label could not be created',
        'No charge was completed. Tap Retry to start over.':
            'No charge was completed. Tap Retry to start over.',
        "Can't buy a UPS label — this order has no shipping address. Add an address in Shopify admin or change the pickup location via Tools → Change Pickup Location.":
            "Can't buy a UPS label — this order has no shipping address. Add an address in Shopify admin or change the pickup location via Tools → Change Pickup Location.",
        'Can\'t buy a UPS label — the shipping rate looks like a pickup-store name ("{title}"). Convert to a pickup order via Tools → Change Pickup Location.':
            'Can\'t buy a UPS label — the shipping rate looks like a pickup-store name ("{title}"). Convert to a pickup order via Tools → Change Pickup Location.',
        'Print the shipping label + packing slip':
            'Print the shipping label + packing slip',
        'Reprint Label':                'Reprint Label',
        'Reopen the packing slip and re-fire the print dialog':
            'Reopen the packing slip and re-fire the print dialog',
        'Reprint Packing Slip':         'Reprint Packing Slip',

        // ── Items count inflection (used as `t('{n} item', {n}) + t('s')` is
        //    brittle; we keep a single key with proper plural agreement) ─────
        '{n} item':                     '{n} item',
        '{n} items':                    '{n} items',
        'Item':                         'Item',
    },

    es: {
        // ── Common ─────────────────────────────────────────────────────────
        'Cancel':                       'Cancelar',
        'Confirm':                      'Confirmar',
        'OK':                           'Aceptar',
        'Yes':                          'Sí',
        'No':                           'No',
        'Save':                         'Guardar',
        'Done':                         'Listo',
        'Close':                        'Cerrar',
        'Back':                         'Atrás',
        'Next':                         'Siguiente',
        'Loading…':                     'Cargando…',
        'Loading order…':               'Cargando pedido…',
        'Searching…':                   'Buscando…',
        'Sign out':                     'Cerrar sesión',
        'Network error. Please try again.': 'Error de red. Por favor inténtelo de nuevo.',
        'Could not connect. Please try again.': 'No se pudo conectar. Por favor inténtelo de nuevo.',
        'Search by customer name or order number…': 'Buscar por nombre del cliente o número de pedido…',
        'Search order or scan barcode…': 'Buscar pedido o escanear código…',
        'Scan barcode…':                'Escanear código…',
        'Scan parent product barcode…': 'Escanear código del producto…',
        'Scan order barcode':           'Escanear código del pedido',
        'Open camera scanner':          'Abrir escáner',
        'No results found.':            'Sin resultados.',
        'No items to pick on this order.': 'No hay artículos para recoger en este pedido.',
        'Order is currently being picked.': 'Este pedido se está recogiendo en este momento.',
        'Order is currently being picked by another user.': 'Otro usuario está recogiendo este pedido.',
        'Sort:':                        'Orden:',
        'Show:':                        'Mostrar:',
        'Refresh':                      'Actualizar',

        // ── Picking Portal ─────────────────────────────────────────────────
        'Picking Portal':               'Portal de Recogida',
        'No location assigned. Use "View as" in the admin bar to select a location, or sign in as a location user.':
            'No tiene ubicación asignada. Use "Ver como" en la barra de administración para seleccionar una ubicación, o inicie sesión como usuario de ubicación.',
        'Multiple locations ({n})':     'Múltiples ubicaciones ({n})',
        'All Locations':                'Todas las ubicaciones',
        'Tap to dismiss':               'Toque para cerrar',
        'Picked':                       'Recogido',
        'Unpicked':                     'No recogido',
        'Mark as picked':               'Marcar como recogido',
        'Items remaining':              'Artículos restantes',
        'Items picked':                 'Artículos recogidos',
        'Total items':                  'Total de artículos',
        'Complete!':                    '¡Completo!',
        'Pick complete':                'Recogida completa',
        'All items picked':             'Todos los artículos recogidos',
        'Save & finish':                'Guardar y terminar',
        'Save and exit':                'Guardar y salir',
        'Pause and exit':               'Pausar y salir',
        'Back to Order Search':         'Volver a búsqueda de pedidos',
        'Open in admin':                'Abrir en administración',
        'Notes':                        'Notas',
        'Customer':                     'Cliente',
        'Order':                        'Pedido',
        'Bin':                          'Casillero',
        'Bin location':                 'Ubicación del casillero',
        'Set bin':                      'Asignar casillero',
        'No bin assigned':              'Sin casillero asignado',
        'This order has been taken by another picker. Your picks have not been saved.':
            'Otro recolector ha tomado este pedido. Sus recogidas no se han guardado.',
        'Manual':                       'Manual',
        'Scan':                         'Escaneo',
        'Scanned':                      'Escaneado',
        'Type:':                        'Tipo:',
        'Base':                         'Base',
        'Embellishments':               'Adornos',
        'Embel.':                       'Adornos',
        'All':                          'Todos',
        'Filter':                       'Filtrar',
        'Filter by location':           'Filtrar por ubicación',
        'Sort: Custom':                 'Orden: Personalizado',
        'Sort: Name':                   'Orden: Nombre',
        'Sort: Newest':                 'Orden: Más recientes',
        'Sort: Oldest':                 'Orden: Más antiguos',
        'Custom':                       'Personalizado',
        'Newest':                       'Más recientes',
        'Oldest':                       'Más antiguos',
        'Name':                         'Nombre',
        'Could not save your picks. Please try again.': 'No se pudieron guardar sus recogidas. Por favor inténtelo de nuevo.',
        'Are you sure you want to exit? Your progress will be saved.':
            '¿Está seguro de que desea salir? Su progreso se guardará.',
        'For fullscreen: tap':          'Para pantalla completa: toque',
        'Share':                        'Compartir',
        'Add to Home Screen':           'Agregar a la pantalla de inicio',
        'Open & Print Label':           'Abrir e imprimir etiqueta',
        'Pickup':                       'Recogida en tienda',
        'Shipping':                     'Envío',
        'Failed to load order.':        'No se pudo cargar el pedido.',
        'Product Not In Order':         'Producto no está en el pedido',
        'Already Fully Scanned':        'Ya completamente escaneado',
        'Debag {title} before continuing': 'Desembolse {title} antes de continuar',
        'Debag — {title}':              'Desembolsar — {title}',
        'Debagged':                     'Desembolsado',
        'On Hand: {n}':                 'En existencia: {n}',
        'Available: {n}':               'Disponible: {n}',
        '← Back & Save':                '← Atrás y guardar',
        '← Back to search':             '← Volver a búsqueda',
        '← Return to Order':            '← Volver al pedido',
        'Saving…':                      'Guardando…',
        '✓ Mark as Picked & Back to Search': '✓ Marcar como recogido y volver',
        '↩ Sign Out':                   '↩ Cerrar sesión',
        'Sign Out':                     'Cerrar sesión',
        'Could not update Shopify — tap Mark as Picked to retry.':
            'No se pudo actualizar Shopify — toque Marcar como recogido para reintentar.',
        'Could not update Shopify — tap Complete to retry.':
            'No se pudo actualizar Shopify — toque Completar para reintentar.',
        'Could not claim order. Please try again.': 'No se pudo reclamar el pedido. Por favor inténtelo de nuevo.',
        'Please open this order from the search page.':
            'Por favor abra este pedido desde la página de búsqueda.',
        'Location':                     'Ubicación',
        'Type':                         'Tipo',
        'No location':                  'Sin ubicación',
        'No unfulfilled orders found for "{q}"': 'No se encontraron pedidos pendientes para "{q}"',
        'On Hand:':                     'En existencia:',
        'Available:':                   'Disponible:',
        'Scan Barcode':                 'Escanear código',
        'Failed to load portal state.': 'No se pudo cargar el estado del portal.',
        'Failed to load order details.':'No se pudieron cargar los detalles del pedido.',
        'No bundle in this order matches the scanned barcode.': 'Ningún paquete de este pedido coincide con el código escaneado.',
        'Barcode:':                     'Código:',
        'Garment':                      'Prenda',
        'Partially Picked':             'Parcialmente recogido',
        '← Back to Board':              '← Volver al tablero',
        '✓ Done — Move to Pressed':     '✓ Listo — Mover a estampados',
        'Image':                        'Imagen',
        'Item':                         'Artículo',
        'Unfulfilled':                  'Sin procesar',
        'No orders found for "{q}"':    'No se encontraron pedidos para "{q}"',
        'QA Failed —':                  'Inspección rechazada —',
        'Next →':                       'Siguiente →',
        '← Back':                       '← Atrás',
        'Partial Fulfillment':          'Procesamiento parcial',
        'Packing Complete —':           'Empaque completo —',
        'Passed QC —':                  'Aprobado —',
        'Excluded —':                   'Excluido —',
        'item':                         'artículo',
        'items':                        'artículos',
        'Bundle':                       'Paquete',
        'Splitting…':                   'Dividiendo…',
        'Split Fulfillment — {n} Item{s} Ready →': 'Dividir procesamiento — {n} artículo{s} listo →',
        'Fulfillment Split':            'Procesamiento dividido',
        '{n} item{s} moved into a ready-to-ship fulfillment order in Shopify.':
            '{n} artículo{s} movido a un procesamiento listo para enviar en Shopify.',
        'Fulfillment failed':           'Error en el procesamiento',
        'Network error creating fulfillment': 'Error de red al crear el procesamiento',
        'No unscanned item found for barcode: {code}': 'No se encontró artículo sin escanear para el código: {code}',
        'Every item in this order has already passed QC. Use Reset Packing History on the order page to start over.':
            'Todos los artículos de este pedido ya pasaron la inspección. Use "Reiniciar historial de empaque" en la página del pedido para volver a empezar.',
        'done':                         'listo',
        'Unit':                         'Unidad',
        'of':                           'de',
        'Pass QC':                      'Aprobar',
        'Fail QC':                      'Rechazar',
        'QC Failed —':                  'Inspección rechazada —',
        'The shipping rate session expired before Shopify finished generating the label. No charge was completed. Tap Retry, then tap "Fulfill & Create Label" again to get a fresh rate.':
            'La sesión de tarifa de envío expiró antes de que Shopify terminara de generar la etiqueta. No se realizó ningún cargo. Toque Reintentar, luego toque "Procesar y crear etiqueta" nuevamente para obtener una tarifa nueva.',
        'This order has already been transferred to its pickup location. No action available here.':
            'Este pedido ya se transfirió a su ubicación de recogida. No hay acción disponible aquí.',
        'This order has already been fulfilled. No action available.':
            'Este pedido ya se procesó. No hay acción disponible.',
        'Create Label & Transfer To Pickup Location (Partial)': 'Crear etiqueta y transferir a ubicación de recogida (parcial)',
        'Create Label & Transfer To Pickup Location':          'Crear etiqueta y transferir a ubicación de recogida',
        'Print Bulk Delivery Slip':             'Imprimir hoja de entrega en bloque',
        'Print Bulk Delivery Slip (Partial)':   'Imprimir hoja de entrega en bloque (parcial)',
        'Partially Fulfill Order':      'Procesar pedido parcialmente',
        'UPS Ground':                   'UPS Ground',
        'Confirm & Buy Label':          'Confirmar y comprar etiqueta',
        'Label purchased':              'Etiqueta comprada',
        'Transferred to pickup location':'Transferido a ubicación de recogida',
        'Open & Print Packing Slip':    'Abrir e imprimir hoja de empaque',
        'Retry':                        'Reintentar',

        // ── Pressing Portal ────────────────────────────────────────────────
        'Pressing Portal':              'Portal de Estampado',
        'No bundles to press.':         'No hay paquetes para estampar.',
        'Return to Search':             'Volver a la búsqueda',
        'Multiple Players':             'Múltiples jugadores',
        'Product':                      'Producto',
        'Player':                       'Jugador',
        'Players':                      'Jugadores',
        'Unpressed':                    'Sin estampar',
        'Pressed':                      'Estampado',
        'PRESSED':                      'ESTAMPADO',
        'Now Pressing':                 'Estampando ahora',
        'Press':                        'Estampar',
        'Mark as pressed':              'Marcar como estampado',
        'Mark as unpressed':            'Marcar como no estampado',
        'Bundles':                      'Paquetes',
        'Items':                        'Artículos',
        'Temp':                         'Temp.',
        'Pressure':                     'Presión',
        'Time':                         'Tiempo',
        'Peel':                         'Pelar',
        'Recipe':                       'Receta',
        'Pressing instructions':        'Instrucciones de estampado',
        'Not in This Order':            'No está en este pedido',
        'Already Pressed':              'Ya estampado',
        'This item has already been moved to':  'Este artículo ya se ha movido a',
        'and the order only contains one of it.': 'y el pedido solo contiene uno.',
        'of this item have already been moved to': 'de este artículo ya se han movido a',
        'Are you sure you want to exit? Your pressing progress will be saved.':
            '¿Está seguro de que desea salir? Su progreso de estampado se guardará.',
        'Save & exit':                  'Guardar y salir',
        'Open admin':                   'Abrir administración',

        // ── Packing / QC Portal ────────────────────────────────────────────
        'Packing Portal':               'Portal de Empaque',
        'Select location…':             'Seleccionar ubicación…',
        'Enter PIN':                    'Ingrese su PIN',
        'PIN must be 4 digits.':        'El PIN debe tener 4 dígitos.',
        'Invalid PIN. Please try again.': 'PIN inválido. Por favor inténtelo de nuevo.',
        'Please select a portal type.': 'Por favor seleccione un tipo de portal.',
        'READY FOR QC':                 'LISTO PARA INSPECCIÓN',
        'PASSED QC':                    'INSPECCIÓN APROBADA',
        'SEND FOR REWORK':              'ENVIAR A REPROCESO',
        'Not Picked':                   'No recogido',
        'Not Pressed':                  'No estampado',
        'Not Picked & Pass':            'No recogido y aprobar',
        'Not Picked & Fail':            'No recogido y rechazar',
        'Front':                        'Frente',
        'Back side':                    'Atrás',
        'Pass':                         'Aprobar',
        'Fail':                         'Rechazar',
        'Pass or fail this item first': 'Aprueba o rechaza este artículo primero',
        'has not been marked yet.':     'todavía no está marcado.',
        'You scanned':                  'Escaneaste',
        'it opens as soon as you decide.': 'se abrirá en cuanto decidas.',
        'Stay on this item':            'Quedarme en este artículo',
        'All items packed':             'Todos los artículos empacados',
        'Scan a barcode or select an item from the queue below':
            'Escanee un código o seleccione un artículo de la lista de abajo',
        'Now Inspecting':               'Inspeccionando ahora',
        'Already QC\'d':                'Ya inspeccionado',
        'This item has already been QC\'d and the order only contains one of it.':
            'Este artículo ya fue inspeccionado y el pedido solo contiene uno.',
        'of this item have already been QC\'d.':
            'de este artículo ya han sido inspeccionados.',
        'Select the failure reason':    'Seleccione el motivo del rechazo',
        'What should happen to this item?': '¿Qué debe pasar con este artículo?',
        'Item needs to be re-pressed. Packing session will be saved and paused.':
            'El artículo necesita ser reestampado. La sesión de empaque se guardará y pausará.',
        'Exclude this item. Continue packing and fulfill the rest.':
            'Excluir este artículo. Continuar empacando y enviar el resto.',
        'Send for Rework':              'Enviar a reproceso',
        'Exclude & Continue':           'Excluir y continuar',
        'QC Failed':                    'Inspección rechazada',
        'Reason':                       'Motivo',
        'Wrong size':                   'Talla incorrecta',
        'Wrong color':                  'Color incorrecto',
        'Wrong number':                 'Número incorrecto',
        'Wrong name':                   'Nombre incorrecto',
        'Wrong logo':                   'Logo incorrecto',
        'Misalignment':                 'Mal alineado',
        'Print quality':                'Calidad de impresión',
        'Damaged':                      'Dañado',
        'Other':                        'Otro',
        'Buy Label':                    'Comprar etiqueta',
        'Fulfill & Create Label':       'Procesar y crear etiqueta',
        'International Shipment':       'Envío internacional',
        'This is an international shipment, and will need to be shipped through the Shopify admin console.':
            'Este es un envío internacional y deberá enviarse a través de la consola de administración de Shopify.',
        'Destination':                  'Destino',
        'Print Packing Slip':           'Imprimir hoja de empaque',
        'Packing slip printed — finish in Shopify admin':
            'Hoja de empaque impresa — finalizar en la consola de Shopify',
        'Not a Ground Shipment':        'No es un envío terrestre',
        'Please ship using the Shopify console. This is not a ground shipment, and the customer paid for':
            'Envíe usando la consola de Shopify. Este no es un envío terrestre y el cliente pagó por',
        'The order is still split and the packing slip still prints — only the UPS Ground label is skipped.':
            'El pedido se divide igual y la hoja de empaque se imprime — solo se omite la etiqueta UPS Ground.',
        'Packing slip printed — ship in Shopify admin':
            'Hoja de empaque impresa — enviar desde la consola de Shopify',
        'customer paid for':            'el cliente pagó por',
        'Canada — UPS Standard. Customs are declared from the order prices; duties and brokerage are collected from the recipient on delivery.':
            'Canadá — UPS Standard. La aduana se declara con los precios del pedido; los aranceles y el despacho los paga el destinatario al recibir.',
        'Print Label':                  'Imprimir etiqueta',
        'Print packing slip':           'Imprimir hoja de empaque',
        'Mark as Ready for Pickup':     'Marcar como listo para recoger',
        'Splitting fulfillment…':       'Dividiendo procesamiento…',
        'Getting shipping rate…':       'Obteniendo tarifa de envío…',
        'Generating packing slip…':     'Generando hoja de empaque…',
        'Purchasing label…':            'Comprando etiqueta…',
        'Loading PDF…':                 'Cargando PDF…',
        'Print preview':                'Vista previa de impresión',
        'Transfer':                     'Transferir',
        'Mark Picked Up':               'Marcar como recogido',
        'Pickup location':              'Ubicación de recogida',

        // ── Multi-location picker (Picking) ─────────────────────────────────
        'Which location are you working at?': '¿En qué ubicación está trabajando?',
        "This order is split across multiple locations. Choose the one you're working at — your scans and saves will be recorded there.":
            'Este pedido está dividido entre varias ubicaciones. Elija la que está atendiendo — sus escaneos y guardados se registrarán allí.',
        '← Cancel — Back to Search':   '← Cancelar — Volver a búsqueda',
        'Working at:':                  'Trabajando en:',

        // ── Pressing + QC board ────────────────────────────────────────────
        'Close & Save Order':           'Cerrar y guardar pedido',
        'Pressing Not Necessary':       'No requiere estampado',

        // ── QC action bar (shipping labels / packing slips) ────────────────
        'Label could not be created':   'No se pudo crear la etiqueta',
        'No charge was completed. Tap Retry to start over.':
            'No se realizó ningún cargo. Toque Reintentar para empezar de nuevo.',
        "Can't buy a UPS label — this order has no shipping address. Add an address in Shopify admin or change the pickup location via Tools → Change Pickup Location.":
            'No se puede comprar la etiqueta UPS — este pedido no tiene dirección de envío. Agregue una dirección en la consola de Shopify o cambie la ubicación de recogida con Herramientas → Cambiar ubicación de recogida.',
        'Can\'t buy a UPS label — the shipping rate looks like a pickup-store name ("{title}"). Convert to a pickup order via Tools → Change Pickup Location.':
            'No se puede comprar la etiqueta UPS — la tarifa de envío parece ser un nombre de tienda de recogida ("{title}"). Convierta el pedido a recogida con Herramientas → Cambiar ubicación de recogida.',
        'Print the shipping label + packing slip':
            'Imprimir la etiqueta de envío + hoja de empaque',
        'Reprint Label':                'Reimprimir etiqueta',
        'Reopen the packing slip and re-fire the print dialog':
            'Reabrir la hoja de empaque y volver a abrir el diálogo de impresión',
        'Reprint Packing Slip':         'Reimprimir hoja de empaque',

        // ── Items count inflection (single key with placeholder so Spanish
        //    can use the appropriate singular/plural forms naturally) ────────
        '{n} item':                     '{n} artículo',
        '{n} items':                    '{n} artículos',
        'Item':                         'Artículo',
    },
};
